import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const LocationCheck = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 384 512"
      {...props}
    >
      <path
        opacity={0.2}
         fill={props.htmlColor || theme.palette.secondary[500]}
        d="M32 188.6C32 102.6 103.1 32 192 32s160 70.6 160 156.6c0 50.3-25.9 109.4-61.4 165.6-34 53.8-74 100.5-98.6 127.4-24.6-26.9-64.6-73.7-98.6-127.4-35.5-56.2-61.4-115.3-61.4-165.6zm83.2 29l48 64c3.2 4.2 8.2 6.6 13.5 6.4s10.1-3 12.9-7.5l80-128c4.7-7.5 2.4-17.4-5.1-22s-17.4-2.4-22 5.1l-67.6 108.2-34-45.3c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4z"
      />
      <path
         fill={props.htmlColor || theme.palette.secondary[500]}
        d="M32 188.6C32 102.6 103.1 32 192 32s160 70.6 160 156.6c0 50.3-25.9 109.4-61.4 165.6-34 53.8-74 100.5-98.6 127.4-24.6-26.9-64.6-73.7-98.6-127.4-35.5-56.2-61.4-115.3-61.4-165.6zM192 0C86 0 0 84.4 0 188.6 0 307.9 120.2 450.9 170.4 505.4 182.2 518.2 201.8 518.2 213.6 505.4 263.8 450.9 384 307.9 384 188.6 384 84.4 298 0 192 0zm77.6 152.5c4.7-7.5 2.4-17.4-5.1-22s-17.4-2.4-22 5.1l-67.6 108.2-34-45.3c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l48 64c3.2 4.2 8.2 6.6 13.5 6.4s10.1-3 12.9-7.5l80-128z"
      />
    </SvgIcon>
  );
};
